import { styled } from "@mui/material/styles";

const PREFIX = "GoogleLink";
export const classes = {
  root: `${PREFIX}-root`,
};

export const GoogleLink = styled("a")(({ theme }) => ({
  [`&.${classes.root}`]: {
    color: "inherit",
    textDecoration: "underline",
    "&:focus, &:hover, &:visited, &:link, &:active": {
      textDecoration: "none",
      color: "inherit",
    },
  },
}));
